import React from "react";
import { Link, LinkProps } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LocalizedLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function LocalizedLink(props, ref) {
    const { i18n } = useTranslation();

    const lng = i18n.language;

    const to =
      typeof props.to === "string"
        ? `/${lng ?? "en"}/${props.to.replace(/^\/+/, "")}`
        : props.to;

    return <Link ref={ref} {...props} to={to} />;
  }
);

export default LocalizedLink;
